export enum TrackExportType {
    hourOverview = 'hourOverview',
    loket = 'loket',
    tracks = 'tracks',
    workRelatedCostsScheme = 'workRelatedCostsScheme',
}
